<template>
    <div class="apaasCloud">
        <div
            class="apaasCloud-desc"
            :style="{'background-image': `url(${$imageSrcMap.introduction.apaas.building})`}"
        >
            <h1>明树云aPaaS<br>新一代低代码平台</h1>
            <h3>赋能投融资创新 ，助力数字化管理</h3>
            <p>大数据驱动 / 高灵活强兼容 / 多行业应用</p>
            <img
                :src="$imageSrcMap.introduction.apaas.play"
                @click="openVideoModal"
            />
            <dsh-buttons
                class="customizeModal-btn"
                :list="$getOperationList(['openModal', 'openVideoModal'])"
                @click="$dispatchEvent($event)"
            ></dsh-buttons>
            <customize-modal
                v-if="showApplyModal"
                :source="source"
                :title="modalTitle"
                :showApplyModal="showApplyModal"
                :priFormData="priFormData"
                :demandRequire="demandRequire"
                @closeModalFunc="showApplyModal = false"
            ></customize-modal>
            <Modal
                class="apaasCloud-video"
                v-model="showVideoModal"
                :width="960"
                :footer-hide="true"
                @on-cancel="stopVideo"
            >
                <video
                    id='player'
                    controls
                    loop
                    width="960"
                    height="540"
                    :src="$imageSrcMap.introduction.mp4"
                ></video>
            </Modal>

        </div>
        <apaas-cloud-advantage></apaas-cloud-advantage>
        <div class="apaasCloud-solve introduce-container">
            <h3 class="apaasCloud-title">数字化解决方案</h3>
            <p class="apaasCloud-subtitle">融合行业咨询经验，项目全方位精细化统一</p>
            <div class="apaasCloud-solve-content">
                <div
                    v-for="item in solution"
                    :key="item.name"
                    class="apaasCloud-solve-content-item"
                >
                    <Icon :custom="'bico-font '+item.icon"></Icon>
                    <h4>{{item.name}}</h4>
                    <span></span>
                    <p style="text-align:justify">{{item.content}}</p>
                    <dsh-buttons
                        :list="$getOperationList(['openDetailModal'])"
                        @click="$dispatchEvent($event, item.projectType)"
                    ></dsh-buttons>
                </div>
            </div>
        </div>

        <apaas-cloud-partner></apaas-cloud-partner>

        <div class="apaasCloud-database introduce-container">
            <h3 class="apaasCloud-title">部署专属服务器</h3>
            <p class="apaasCloud-subtitle">灵活部署方式，保障信息安全</p>
            <div class="apaasCloud-database-ways">
                <div>
                    <img :src="$imageSrcMap.introduction.apaas.suo">
                    <h4>私有云部署</h4>
                    <p>支持企业本地部署、自建云部署和内局域网部署<br>满足网络安全控制体系的要求</p>
                </div>
                <div>
                    <img :src="$imageSrcMap.introduction.apaas.net">
                    <h4>公有云部署</h4>
                    <p>支持阿里、腾讯、七牛、云上贵州等主流第三方<br>云平台，提供海内外业务快速拓展的有效保障</p>
                </div>
            </div>
        </div>
        <apaas-cloud-personal></apaas-cloud-personal>
    </div>
</template>

<script>
    import apaasCloudAdvantage from "./apaasCloudAdvantage.vue";
    import apaasCloudPartner from "./apaasCloudPartner.vue";
    import apaasCloudPersonal from "./apaasCloudPersonal.vue";
    import customizeModal from "../introduction/customizeModal.vue";

    export default {
        name: "apaasCloud",
        components: {
            apaasCloudAdvantage, apaasCloudPartner, apaasCloudPersonal, customizeModal
        },
        data () {
            return {
                solution: [
                    { name: "政府投资项目全生命周期管理平台", projectType: "government", icon: "bico-customized", content: "可用于PPP和其他各类投资项目全生命周期管理，实现投资项目自谋划、储备、建设、竣工、运营、移交达效全过程的审批、调度、评价及相关方管理" },
                    { name: "投资企业投建营一体化管理平台", projectType: "enterprise", icon: "bico-enterprise", content: "覆盖基建、地产等各类项目投资、建设和运营全生命周期，既可用于总部、区域公司和项目公司分级多项目投前投后管理，也可服务于片区综合开发类单个大型复杂项目" },
                    { name: "专属定制", projectType: "other", icon: "bico-government", content: "基于低代码平台，贴合业务逻辑，专业实施团队可快速定制专属业务场景的数字化解决方案" }
                ],
                showVideoModal: false,
                // 申请试用modal框
                showApplyModal: false,
                priFormData: {},
                demandRequire: true,
                operationMap: {
                    openModal: {
                        name: "申请试用账号",
                        event: "openTrialModal",
                        type: "openModal",
                        size: "large",
                        shape: "circle",
                        btnType: "primary",
                        class: "pink-btn"
                    },
                    openVideoModal: {
                        name: "播放介绍视频",
                        event: "openVideoModal",
                        type: "openVideoModal",
                        size: "large",
                        shape: "circle",
                        btnType: "primary",
                        icon: "md-arrow-dropright",
                        class: "pink-white-btn"
                    },
                    openDetailModal: {
                        name: "了解详情",
                        event: "openApplyModal",
                        type: "openDetailModal",
                        size: "large",
                        shape: "circle",
                        btnType: "primary",
                        class: "pink-btn-small"
                    }
                },
                modalTitle: "",
                source: ""
            };
        },
        created () {
        },
        methods: {
            openTrialModal () {
                // this.modalTitle = "申请试用";
                // this.source = "apply";
                // this.priFormData = {};
                // this.demandRequire = false;
                // this.showApplyModal = true;
                window.open("http://hcomp.bridata.com/register", "_blank");
            },
            // 定制化modal框
            openApplyModal (operation, projectType) {
                this.modalTitle = "为您量身定制数字化解决方案";
                this.source = "customized";
                this.priFormData = {
                    project_type: projectType
                };
                this.demandRequire = true;
                this.showApplyModal = true;
            },
            openVideoModal () {
                this.showVideoModal = true;
                this.startVideo();
            },
            stopVideo () {
                this.$nextTick(() => {
                    let myVideo = document.getElementById("player"); // 对应video标签的ID
                    myVideo.pause();
                });
            },
            startVideo () {
                this.$nextTick(() => {
                    let myVideo = document.getElementById("player"); // 对应video标签的ID
                    myVideo.play();
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/introduction/apaasCloud/apaasCloud.vue